import React from 'react';
import Select from '../../../../components/common/Select';
import styles from './IdeaStatusControl.module.css';

function IdeaStatusControl({ currentStatus, onStatusChange }) {
  const statusOptions = [
    { value: 'pending', label: '대기중' },
    { value: 'team_building', label: '팀 빌딩중' },
    { value: 'team_confirmed', label: '팀 빌딩 완료' },
    { value: 'in_progress', label: '진행중' },
    { value: 'cancel', label: '아이디어 폐기(숨기기)' }
  ];

  return (
    <div className={styles.statusControl}>
      <Select
        label="아이디어 상태"
        value={currentStatus}
        onChange={(e) => onStatusChange(e.target.value)}
        options={statusOptions}
      />
    </div>
  );
}

export default IdeaStatusControl; 